import { useLocation, useNavigate } from "react-router-dom";

import { useGame } from "../header/GameContext";
import KeywordCheck from "./keywordCheck";
import ChatBoxType2 from "../chat/chatType2";
import Header from "../header/header";
import Wrong from "../wrong/wrong";
import { useState, useEffect, useRef } from "react";

import "./keyword.css";

export default function Keyword({
  answerData,
  DateVal,
  titImgclassName,
  timerMode = "run",
  showHeader = true,
}) {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { startTimer, pauseTimer, TOTAL_GAME_TIME } = useGame();
  const [showWrong, setShowWrong] = useState(false);

  useEffect(() => {
    if (timerMode === "run") {
      startTimer();
    } else {
      pauseTimer();
    }
  }, [timerMode]);

  // ✅ state 있을 때 값이 있는 경우만 덮어씀
  if (state) {
    const { answerDataState, DateValState, titImgclassNameState } = state;
    if (answerDataState) answerData = answerDataState;
    if (DateValState) DateVal = DateValState;
    if (titImgclassNameState) titImgclassName = titImgclassNameState;
  }

  const chatRef = useRef(null);

  return (
    <div id="content">
      <Header initialTime={TOTAL_GAME_TIME} missionCount={3} missionTotal={8} />
      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className="mission_tit keywordInputTit"></div>

        <ChatBoxType2
          DateVal={DateVal}
          titImgClass={titImgclassName}
          ref={chatRef}
        />

        <KeywordCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
      </div>
    </div>
  );
}
